import projectFields from '../../Project/StepsFields/defaults'

const items = new Map()

Array.of('privacy', 'cookie').forEach(element => {
  items.set(element, projectFields.get(element))
})
export default items
